import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQS } from "../../lib/data";

export default function FAQ() {
  return (
    <section data-testid="faq-section" className="py-24 md:py-32 bg-[#F8F5EF]">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4 reveal lg:sticky lg:top-32 lg:self-start">
          <div className="flex items-center gap-3 mb-6">
            
            <span className="overline">FAQ</span>
          </div>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] text-[#1A1A1A] tracking-tight">
            Häufige <br />
            <span className="gold-text italic">Fragen</span>.
          </h2>
          <p className="mt-8 max-w-sm text-[14px] leading-relaxed text-[#5A5A5A] font-light">
            Ihre Frage ist nicht dabei? Schreiben Sie uns direkt — Antwort innerhalb
            eines Werktags.
          </p>
        </div>

        <div className="lg:col-span-8 reveal">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`q-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-[#EAE6DE]"
              >
                <AccordionTrigger className="text-left py-7 hover:no-underline group">
                  <span className="font-display text-xl md:text-[26px] leading-tight text-[#1A1A1A] pr-8 group-hover:text-[#FFA500] transition-colors">
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-7 pr-8 text-[15px] leading-[1.7] text-[#4A4A4A] font-light">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
